export default {
  postUser: async ({ commit }, { user }) => {
    // Drop whatever the previous session cached before writing the new one. Signing
    // in does not reload the page, so without this the incoming user inherits the
    // outgoing user's staff list, customers and dashboard.
    commit("resetSession", null, { root: true });
    commit("SET_user", user);
  },
};
